"use client";

export function ContactBlockEditor(_props: {
  block: any;
  locale: "en" | "fa";
  onChange: (patch: (data: any) => any) => void;
}) {
  return (
    <div className="rounded border border-gray-200 bg-gray-50 px-3 py-3 text-sm text-gray-700">
      This block uses the predefined consultation CTA. Leads from it are saved with
      source <code className="rounded bg-white px-1 py-0.5">content_contact_block</code>.
      If this block is rendered on a content page, the lead metadata will also include
      the content slug.
    </div>
  );
}
